module.exports = __webpack_public_path__ + "static/img/mark7-gdAAEgCo.070d321.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/mark7-gdAAEgCo.png
// module id = cpT8
// module chunks = 16